import PhotoviewerSmallViewPort from "./PhotoviewerSmallViewPort";

export default PhotoviewerSmallViewPort;
